import {TariffFlagKey} from 'entities/tariff';

export interface ITariffFeature {
    key: TariffFlagKey,
    label: string,
    title: string,
}

export const TARIFF_FEATURES: ITariffFeature[] = [
    {key: 'monitor_ssl_enabled', label: 'SSL', title: 'Проверка SSL'},
    {key: 'monitor_domain_watch_enabled', label: 'Домен', title: 'Монитор домена'},
    {key: 'monitor_ssl_redirect_watch_enabled', label: 'Редирект', title: 'Редирект https'},
    {key: 'monitor_extended_methods', label: 'Методы', title: 'Расш. методы'},
    {key: 'monitor_parse_errors', label: 'Разбор', title: 'Разбор проблем'},
    {key: 'monitor_frequent_checking', label: 'Частота', title: 'Учащ. мониторинг'},
    {key: 'monitor_content_enabled', label: 'Контент', title: 'Проверка контента'},
    {key: 'monitor_http_basic_auth_enabled', label: 'Auth', title: 'Basic Auth'},
    {key: 'monitor_custom_user_agent_enabled', label: 'Кастомный UA', title: 'Кастомный User-Agent'},
    {key: 'monitor_custom_host_enabled', label: 'Кастомный Host', title: 'Кастомный Host'},
    {key: 'monitor_rkn_watch_enabled', label: 'РКН', title: 'Мониторинг РКН'},
    {key: 'monitor_robots_txt_watch_enabled', label: 'robots', title: 'Проверка robots.txt'},
    {key: 'monitor_screenshot_on_error', label: 'Скриншот', title: 'Скриншот ошибки'},
];
